export default "__VITE_ASSET__D19b8eL5__"